import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Spanish-only hint shown above clinical data sections: records stay in their
 * original language, but the AI can explain them in Spanish via Explain.
 * Clinical FHIR data itself is never translated.
 */
export function ClinicalDataLanguageNotice() {
  const { t, i18n } = useTranslation();
  if (i18n.resolvedLanguage !== 'es') return null;

  return (
    <p className="flex items-start gap-1.5 text-xs text-text-secondary mb-2">
      <Info className="h-3.5 w-3.5 mt-0.5 flex-shrink-0" aria-hidden="true" />
      <span>{t('notice.clinicalDataLanguage')}</span>
    </p>
  );
}
